;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockTwoColumnText from './BlockTwoColumnText';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockTwoColumnText(preview: $preview, id: $id) {
            __typename
            anchorId
            eyebrow
            richHeadline {
                json
            }
            bodyCopy {
                json
            }
            cta {
                ...CTA
            }
            tip
            theme
            flushTop
            flushBottom
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockTwoColumnText },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockTwoColumnText;
}

const BlockTwoColumnTextServer = async ({ id }) => {
    const block = await fetchBlock(id);
    return <BlockTwoColumnText {...block} />;
};

export default BlockTwoColumnTextServer;
